/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import Lottie from 'lottie-react'
import FailedAnimation from 'components/Animations/FailedAnimation.json'
import clsx from 'clsx'
import UiAuthFormShell from 'components/Ui/UiAuthFormShell'
import UiButton, {UiButtonSize, UiButtonStyle, UiButtonType,} from 'components/Ui/UiButton'

const RecoveryError = () => {
    const { t } = useTranslation()
    const [messageComplete, setMessageComplete] = useState<boolean>(false)

    return (
        <UiAuthFormShell
            title={t('Password change error')}
            subtitle={t(
                'Continue to recovery from the main page. If problem remains, please contact support.'
            )}
        >
            <div className={clsx('flex flex-col items-center space-y-6')}>
                <div
                    className={clsx(
                        'w-24 h-24 rounded-full bg-red-50 dark:bg-red-900/20',
                        'flex items-center justify-center p-4'
                    )}
                >
                    <Lottie
                        animationData={FailedAnimation}
                        loop={false}
                        onComplete={() => setMessageComplete(true)}
                        className={clsx('w-full h-full')}
                    />
                </div>

                <div
                    className={clsx(
                        'w-full transition-all duration-500 ease-in-out',
                        messageComplete
                            ? 'opacity-100 translate-y-0'
                            : 'opacity-0 translate-y-4'
                    )}
                >
                    <div className={clsx('flex justify-center')}>
                        <Link to={'/'} className={clsx('w-full')}>
                            <UiButton
                                id={'btn-recovery-error-home'}
                                style={UiButtonStyle.Primary}
                                size={UiButtonSize.Medium}
                                type={UiButtonType.Button}
                                title={t('Back to main')}
                                className={clsx('w-full')}
                            />
                        </Link>
                    </div>
                </div>
            </div>
        </UiAuthFormShell>
    )
}

export default RecoveryError
